import { render, staticRenderFns } from "./stockDifferenceAction.vue?vue&type=template&id=428af5b4&scoped=true"
import script from "./stockDifferenceAction.vue?vue&type=script&lang=js"
export * from "./stockDifferenceAction.vue?vue&type=script&lang=js"
import style0 from "./stockDifferenceAction.vue?vue&type=style&index=0&id=428af5b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428af5b4",
  null
  
)

export default component.exports